// ============================================================================
// KLINISOL CRO - Session Manager Component
// Purpose: FDA 21 CFR Part 11 Compliant Session Timeout Management
// Requirement: 15-minute inactivity timeout with audit logging
// ============================================================================

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const SessionManager = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const TIMEOUT_DURATION = 15 * 60 * 1000; // 15 minutes in milliseconds

    useEffect(() => {
        if (!user) return; // Don't run if user not logged in

        let timeoutId;

        const resetTimer = () => {
            // Clear existing timeout
            if (timeoutId) {
                clearTimeout(timeoutId);
            }

            // Set new timeout
            timeoutId = setTimeout(async () => {
                // Session timeout - logout user
                await logout();
                alert('Your session has expired due to inactivity. Please log in again.');
                navigate('/login');
            }, TIMEOUT_DURATION);
        };

        // Events that reset the timer
        const events = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'];

        // Reset timer on user activity
        events.forEach(event => {
            window.addEventListener(event, resetTimer);
        });

        // Initialize timer
        resetTimer();

        // Cleanup
        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            events.forEach(event => {
                window.removeEventListener(event, resetTimer);
            });
        };
    }, [user, logout, navigate]);

    return null; // This component doesn't render anything
};

export default SessionManager;
